export { createEmailThread, sendEmailReply } from '../_internal/clients/EmailThreadClient';